export const styles = {
  container: { paddingBottom: '$6' },
  sectionHeader: { marginBottom: '$6', cursor: 'pointer' },
  siteDisplayHeader: { marginBottom: '$2', marginTop: '$6', cursor: 'pointer' },
  buttonsContainer: { marginTop: '$6' },
  warningBox: {
    backgroundColor: '$warning-light',
    border: '1px solid $warning-standard',
    borderRadius: '$2',
    padding: '$4',
    marginBottom: '$4'
  },
  warningText: {
    color: '$warning-dark',
    fontSize: '$body-small'
  },
  descriptionText: {
    marginBottom: '$6',
    fontSize: '$body-small',
    color: '$medium-medium',
    lineHeight: '$default'
  }
}
